/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Duration_MinutesInputs */



/**
* | output |
* | --- |
* | "{minutes} min" |
*
* @param {Duration_MinutesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const duration_minutes = /** @type {((inputs: Duration_MinutesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duration_MinutesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.minutes} min`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.minutes} min`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.minutes} min`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.minutes} мин`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.minutes} min`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.minutes} 分钟`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.minutes}分`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.minutes} मिनट`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.minutes} min`)
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
});